<script>
import ListingModel from "@/views/Request/RecruitmentRequest/Components/ListingModel.vue";

export default {
    name: "RecruitmentDecisions",
    components: {ListingModel},
};
</script>

<template>
    <ListingModel type="DECISION"/>
</template>